import { __require as requireContainer } from "./container.js";
import { __require as requireInput } from "./input.js";
import { __require as requireParser } from "./parser.js";
var parse_1;
var hasRequiredParse;
function requireParse() {
  if (hasRequiredParse) return parse_1;
  hasRequiredParse = 1;
  let Container = requireContainer();
  let Input = requireInput();
  let Parser = requireParser();
  function parse(css, opts) {
    let input = new Input(css, opts);
    let parser = new Parser(input);
    try {
      parser.parse();
    } catch (e) {
      throw e;
    }
    return parser.root;
  }
  parse_1 = parse;
  parse.default = parse;
  Container.registerParse(parse);
  return parse_1;
}
export {
  requireParse as __require
};
//# sourceMappingURL=parse.js.map
